import * as React from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

const Label = React.forwardRef(({ className, ...props }, ref) => (
  <label ref={ref} className={twMerge(clsx("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70", className))} {...props} />
));
Label.displayName = "Label";

export { Label };
